import React, { useMemo, useEffect } from 'react'
import objectPath from 'object-path'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useHtmlClassService } from '../../_core/MetronicLayout'
import { LanguageSelectorDropdown } from '../extras/dropdowns/LanguageSelectorDropdown'
import { QuickUserToggler } from '../extras/QuiclUserToggler'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import * as actions from '../../../../app/modules/Application/_redux/adminSetting/adminSettingAction'
import SVG from 'react-inlinesvg'
import { toAbsoluteUrl } from '../../../_helpers'

export function Topbar() {
	const uiService = useHtmlClassService()
	const dispatch = useDispatch()

	const { microsolution } = useSelector(
		(state) => ({
			microsolution: state.auth.microsolution,
		}),
		shallowEqual,
	)
	useEffect(() => {
		dispatch(actions.fetchAdminSetting())
	}, [])

	const { user, adminSetting } = useSelector(
		(state) => ({
			user: state.auth.user,
			adminSetting: state.adminSetting.currentAdminSetting,
		}),
		shallowEqual,
	)

	const { profile } = user

	const layoutProps = useMemo(() => {
		return {
			viewQuickPanelDisplay: objectPath.get(
				uiService.config,
				'extras.quick-panel.display',
			),
			viewLanguagesDisplay: objectPath.get(
				uiService.config,
				'extras.languages.display',
			),
			viewUserDisplay: objectPath.get(uiService.config, 'extras.user.display'),
		}
	}, [uiService])

	return (
		<div className='topbar'>
			{layoutProps.viewQuickPanelDisplay && microsolution && (
				<OverlayTrigger
					placement='bottom'
					overlay={<Tooltip id='quick-panel-tooltip'>View Apps</Tooltip>}
				>
					<div
						className='topbar-item'
						data-toggle='tooltip'
						title='Quick panel'
						data-placement='right'
					>
						<div
							className='btn btn-icon btn-clean btn-lg mr-1'
							id='kt_quick_panel_toggle'
						>
							<span className='svg-icon svg-icon-xl svg-icon-primary'>
								<SVG
									src={toAbsoluteUrl(
										'/media/svg/icons/Layout/Layout-4-blocks.svg',
									)}
								/>
							</span>
						</div>
					</div>
				</OverlayTrigger>
			)}
			{adminSetting &&
				(adminSetting.internalizationSettingAllowed === 'Yes' ||
					profile === 2) &&
				layoutProps.viewLanguagesDisplay && <LanguageSelectorDropdown />}
			{layoutProps.viewUserDisplay && <QuickUserToggler />}
		</div>
	)
}
